/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ThreadLastSeen } from './threadLastSeen';
import { ThreadScope } from './threadScope';


export interface Thread { 
    assigned?: Array<string>;
    chat?: Array<object>;
    createdAt?: string;
    currentNode?: string;
    dataStore?: object;
    empty?: boolean;
    executionId?: string;
    id?: string;
    lastNode?: string;
    /**
     * Is an array that contains information on when each user last viewed a message in the thread. Not all users are guaranteed to be present, e.g. if a user has not viewed a message yet.
     */
    lastSeen?: Array<ThreadLastSeen>;
    methodKey?: string;
    methodParams?: any | null;
    name?: string;
    nodeTemplate?: object;
    path?: string;
    scope?: ThreadScope;
    status?: Thread.StatusEnum;
}
export namespace Thread {
    export type StatusEnum = 'OPEN' | 'COMPLETED' | 'CLOSED';
    export const StatusEnum = {
        Open: 'OPEN' as StatusEnum,
        Completed: 'COMPLETED' as StatusEnum,
        Closed: 'CLOSED' as StatusEnum
    };
}


